export const getTotalPage = (total, size) => Math.ceil(total / size);

export const calculateSingleTax = (tax, totalRevenue, isRounded) => {
  const value =
    (tax?.rate / 100) *
    (tax?.tax_bases / 100) *
    Number((totalRevenue || 0).toFixed(2));
  return isRounded ? Math.round(value) : value;
};
export const calculateTotalRevenue = (songs, isRounded) => {
  const totalRevenue = songs?.reduce((acc, song) => {
    const value = (song?.revenue || 0).toFixed(2);
    const songTotal = song?.qty * (isRounded ? Math.round(value) : value);
    return acc + songTotal;
  }, 0);

  return totalRevenue || 0;
};

export const calculateTotalClaimsRevenue = (
  items,
  exchangeRate = 1,
  isRounded
) => {
  const totalOriginalRevenue = items?.reduce((acc, val) => {
    const value = Number((val?.original_currency_revenue || 0).toFixed(2));
    const total = isRounded ? Math.round(value) : value;
    return acc + total;
  }, 0);

  return totalOriginalRevenue * exchangeRate;
};

export const calculateTotalClaimsBaseRevenue = (
  items,
  exchangeRate = 1,
  isRounded
) => {
  const totalOriginalRevenue = items?.reduce((acc, val) => {
    const value = Number((val?.base_currency_revenue || 0).toFixed(2));
    const total = isRounded ? Math.round(value) : value;
    return acc + total;
  }, 0);

  return totalOriginalRevenue * exchangeRate;
};

export const calculateTotalTax = (taxes, totalRevenue) => {
  return taxes?.reduce((total, tax) => {
    const afterCountTax =
      (tax.rate / 100) * (tax.tax_bases / 100) * Number(totalRevenue || 0);
    return tax.method === "addition"
      ? total + afterCountTax
      : total - afterCountTax;
  }, 0);
};

export const calculateTotalTaxClaim = (taxes, totalRevenue) => {
  const revenue = Number(totalRevenue || 0);
  return taxes?.reduce((total, tax) => {
    const rate = Number(tax.rate) || 0;
    const taxBase = Number(tax.tax_bases) || 0;

    const afterCountTax = Number(
      ((rate / 100) * (taxBase / 100) * revenue).toFixed(2)
    );
    return tax.method === "addition"
      ? total + afterCountTax
      : total - afterCountTax;
  }, 0);
};

export const generateUniqueId = (existingIds = []) => {
  let newId;
  do {
    newId = Math.floor(1000 + Math.random() * 9000);
  } while (existingIds.includes(newId));
  return newId;
};

export default {
  getTotalPage,
  calculateSingleTax,
  calculateTotalRevenue,
  calculateTotalTax,
  generateUniqueId,
};
